/**
 * @description gestion de la hauteur de l'image
 */

/* global bsBreakpoints */

(() => {
	const item = document.querySelectorAll('div.rt__grid__result');
	const root = document.querySelector('.actualites__body__result');

	// FUNCTION
	const annuaireItemHeight = () => {
		item.forEach((el) => {
			const h3Height = el.querySelector('h3').offsetHeight;
			const lead = el.querySelector('div.lead');
			const annuaire = el.querySelector('.annuaire');

			if (annuaire && h3Height >= 60 && lead) {
				el.style.height = '270px';
			} else {
				el.style.height = '245px';
			}
		});
	};

	const masonry = () => {
		const rootCount = root.children.length;

		if (
			(bsBreakpoints.detectBreakpoint() === 'xLarge' ||
				bsBreakpoints.detectBreakpoint() === 'large') &&
			rootCount > 1
		) {
			let id = 0;
			item.forEach((tuiles) => {
				id++;
				tuiles.setAttribute('id', `${id}`);

				if (tuiles.style.height === '270px') {
					// eslint-disable-next-line no-unused-vars
					const index = tuiles.getAttribute('id');
				}
			});
		}
	};

	// GO 🚀
	const init = () => {
		annuaireItemHeight();
		masonry();
	};

	init();
})();
